export const musician = {
  name: "Jackson Lacefield",
  subtitle: "Musician \u2022 Communicator",
  tagline: "Serving through music, leading through faith.",
  roleLine: "Tenor \u2014 Baylor University",
  email: "lacefieldjackson@gmail.com",
  phone: "940-205-3728",
  location: "Dallas / Ft. Worth, Texas & Waco",
  logoUrl: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/5634ff68-ae8a-40e1-8564-0ee9710c72fa_compressed_JacksonLacefieldLogo.webp",
  youtubeChannelUrl: "https://www.youtube.com/@jacksonlacefield4977",
  instagramUrl: "https://www.instagram.com/jacksonlacefieldmusic/",

  heroImage: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/45674621-1461-47a6-85af-49757092c6cf_compressed_A7404095_1_optimized_5000.webp",
  headshot: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/6255996a-41e7-4aef-8301-1276314885f2_compressed_IMG_2023.webp",
  galleryImages: [
    {
      id: "g-1",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/1a4e4b57-2ae1-446b-8e3c-60fa3e3aec2c_compressed_195a4581-98ec-4d2e-8d95-be9c8ad0f5fe_compressed_A7403827_optimized_5000.webp",
      alt: "Jackson Lacefield at piano in a grand hall with stained glass windows",
      caption: "Piano Reflection",
    },
    {
      id: "g-2",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/9dbeb69b-c9fa-4da4-88cc-e6f81b217adf_compressed_665d3c59-13ef-425a-868d-21ca91de7aaf_compressed_A7403291_11zon.webp",
      alt: "Jackson Lacefield at sunset with arms crossed",
      caption: "Golden Hour",
    },
    {
      id: "g-3",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/a8e29b62-7fd9-4dd9-9f53-63bb59fdf8b9_compressed_894c3592-b3b5-4cba-a805-bf32e1f01cf9_compressed_A7403217_optimized_5000.webp",
      alt: "Jackson sitting outdoors on a grassy lawn with lush greenery",
      caption: "Quiet Reflection",
    },
    {
      id: "g-4",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/7fa4ffe9-f478-4019-8bcf-837dda0b7e0d_compressed_c3ae53ad-f595-4dfb-a0eb-8a5ac6c1e124_compressed_A7403325_11zon.webp",
      alt: "Jackson smiling against a dark brick wall",
      caption: "Candid Smile",
    },
    {
      id: "g-5",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/9e56ceee-b3ac-409e-9f61-4e7e9c1890e5_compressed_c16495e9-1182-4992-abe6-5a8114a63fa6_compressed_A7403713_optimized_5000.webp",
      alt: "Jackson in formal attire with stained glass windows behind",
      caption: "Formal Portrait",
    },
    {
      id: "g-6",
      src: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/55e2b171-27c7-4467-be52-b78ec5796b12_compressed_fd54877d-993d-4227-a653-780248c22b72_compressed_A7403073_11zon.webp",
      alt: "Jackson at piano in a church sanctuary with stained glass",
      caption: "Sanctuary Performance",
    },
  ],

  about: {
    headline: "Called to Lead Through Music",
    bio: "I am a tenor and church musician from the Dallas / Ft. Worth area, currently studying Church Music at Baylor University. I believe music is one of the most powerful ways to draw people closer to Christ, and I am committed to using every gift God has given me to serve His Kingdom.",
    extended: "From leading Sunday worship to serving on the worship team at First Baptist Church Waco, my calling is to create space for people to encounter God through music. Gifted with perfect pitch, I have been able to train hard and learn many instruments such as vocals, violin, piano, guitar, bass, and drums.\n\nI have a deep love for composing choral music — arranging voices in harmony feels like a small reflection of the unity Christ calls us to. Whether I am singing Italian art songs, playing violin in a chamber ensemble, or leading a congregation in worship, I approach every genre with reverence and joy.\n\nBeyond music, I am passionate about serving youth, mentoring at Frontier Christian Camp, and exploring the outdoors. My faith is the foundation of everything I do, and I believe that both music and nature are gifts that draw us closer to the Creator.",
    pullQuote: "I want every note I sing to point back to the One who gave me the voice to sing it.",
  },

  faith: {
    title: "Rooted in Faith",
    text: "My faith is the foundation of everything I do. It is not just the reason I sing \u2014 it is the reason I live. From leading Sunday morning worship to serving at camp, every note I play and every word I sing is an act of worship. I believe music is one of the most powerful ways to draw people closer to Christ, and I am committed to using every gift God has given me to serve His Kingdom.",
    scripture: "Shout for joy to the Lord, all the earth. Worship the Lord with gladness; come before him with joyful songs.",
    scriptureRef: "Psalm 100:1\u20132",
  },

  music: {
    title: "A Deep Passion for Music",
    text: "Music has been my language since I was a child. I have a particular love for composing choral music, arranging voices in harmony that reflect the unity Christ calls us to. Whether I am singing Italian art songs, playing violin in chamber and orchestral ensembles, or leading a congregation in worship, I approach every genre with reverence and joy. Classical music and contemporary worship are not opposed — they are both expressions of the creativity God placed in us.",
  },

  outdoors: {
    title: "Beyond the Stage",
    text: "When I am not making music, I enjoy being outdoors, working out, collecting LEGOs, spending time in fellowship with friends, and eating at Chili's. Life is richer when we find joy in the simple things God has given us.",
    scripture: "The heavens declare the glory of God; the skies proclaim the work of his hands.",
    scriptureRef: "Psalm 19:1",
  },

  training: [
    "Church Music Major, Baylor University",
    "Classical Piano & Violin Training (Early Childhood)",
    "Perfect Pitch",
    "Multi-Instrumentalist: Vocals, Violin, Piano, Guitar, Bass, Drums",
    "Musical Theatre Experience",
    "Public Speaking & Leadership",
    "Composer/Arranger of Worship Music",
  ],

  mediaCategories: [
    {
      id: "worship",
      label: "Worship / Church",
      title: "Worship & Church Performances",
      subtitle: "Leading congregations in praise and worship",
      accentColor: "accent",
      items: [
        {
          id: "w-1",
          title: "O Come to the Altar",
          description: "A heartfelt worship performance leading the congregation into a moment of surrender and praise.",
          context: "Sunday Worship at First Baptist Waco",
          youtubeId: "LFJ6LQS2WMA",
          embedUrl: "https://www.youtube.com/embed/LFJ6LQS2WMA",
          thumbnail: "https://img.youtube.com/vi/LFJ6LQS2WMA/maxresdefault.jpg",
          type: "video",
        },
        {
          id: "w-2",
          title: "O Come All Ye Faithful",
          description: "A reverent and joyful arrangement of the classic Christmas hymn, featuring violin.",
          context: "Christmas Hymn",
          youtubeId: "aMJhRZhowjg",
          embedUrl: "https://www.youtube.com/embed/aMJhRZhowjg",
          thumbnail: "https://img.youtube.com/vi/aMJhRZhowjg/maxresdefault.jpg",
          type: "video",
        },
      ],
    },
    {
      id: "vocals",
      label: "Vocals / Classical",
      title: "Vocals & Classical Repertoire",
      subtitle: "Italian art songs and classical tenor works",
      accentColor: "primary",
      items: [
        {
          id: "v-1",
          title: "Malia",
          description: "A beautiful Italian art song performed with expressive tenor line and warm phrasing.",
          context: "Italian Art Song",
          composer: "Francesco Paolo Tosti",
          youtubeId: "CFIRPQBIX8o",
          embedUrl: "https://www.youtube.com/embed/CFIRPQBIX8o",
          thumbnail: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/45674621-1461-47a6-85af-49757092c6cf_compressed_A7404095_1_optimized_5000.webp",
          type: "video",
        },
        {
          id: "v-2",
          title: "Fair House of Joy",
          description: "An English art song showcasing lyrical tenor tone and sensitive interpretation.",
          context: "English Art Song",
          composer: "Roger Quilter",
          youtubeId: "4l5GEd7jyuE",
          embedUrl: "https://www.youtube.com/embed/4l5GEd7jyuE",
          thumbnail: "https://storage.readdy-site.link/project_files/d27b1ed1-d59b-43f0-8488-9d510448f5f8/195a4581-98ec-4d2e-8d95-be9c8ad0f5fe_compressed_A7403827_optimized_5000.webp",
          type: "video",
        },
      ],
    },
    {
      id: "theatre",
      label: "Musical Theatre",
      title: "Musical Theatre",
      subtitle: "Stage performances and theatrical vocals",
      accentColor: "secondary",
      items: [
        {
          id: "t-1",
          title: "Top of the World - Tuck Everlasting",
          description: "A musical theatre selection from Tuck Everlasting, showcasing vocal versatility and dramatic expression.",
          context: "Musical Theatre",
          youtubeId: "zMo0RX-PKLY",
          embedUrl: "https://www.youtube.com/embed/zMo0RX-PKLY",
          thumbnail: "https://img.youtube.com/vi/zMo0RX-PKLY/hqdefault.jpg",
          type: "video",
        },
        {
          id: "t-2",
          title: "Sit Down You're Rocking the Boat",
          description: "A lively musical theatre number with energetic performance and stage presence.",
          context: "Musical Theatre",
          youtubeId: "f7wvPH05B7k",
          embedUrl: "https://www.youtube.com/embed/f7wvPH05B7k",
          thumbnail: "https://img.youtube.com/vi/f7wvPH05B7k/maxresdefault.jpg",
          type: "video",
        },
      ],
    },
    {
      id: "guitar",
      label: "Guitar",
      title: "Guitar",
      subtitle: "Worship leading and acoustic arrangements",
      accentColor: "accent",
      items: [
        {
          id: "g-1",
          title: "I Thank God - Guitar Section",
          description: "A contemporary worship guitar section with expressive phrasing and lead tone.",
          context: "Worship Guitar",
          youtubeId: "tNKvfhcAf30",
          embedUrl: "https://www.youtube.com/embed/tNKvfhcAf30",
          thumbnail: "https://img.youtube.com/vi/tNKvfhcAf30/hqdefault.jpg",
          type: "video",
        },
        {
          id: "g-2",
          title: "Beat It - Guitar Solo",
          description: "A high-energy guitar solo showcasing technical skill and stage presence.",
          context: "Guitar Solo",
          youtubeId: "PJx6Ct8CGM8",
          embedUrl: "https://www.youtube.com/embed/PJx6Ct8CGM8",
          thumbnail: "https://img.youtube.com/vi/PJx6Ct8CGM8/hqdefault.jpg",
          type: "video",
        },
      ],
    },
    {
      id: "piano",
      label: "Piano & Violin",
      title: "Piano & Violin",
      subtitle: "Classical piano and violin performances",
      accentColor: "primary",
      items: [
        {
          id: "p-1",
          title: "Go Tell It on the Mountain",
          description: "An original piano arrangement of the classic spiritual, blending classical technique with worship heart.",
          context: "Original Piano Arrangement",
          youtubeId: "69MSII3rEDg",
          embedUrl: "https://www.youtube.com/embed/69MSII3rEDg",
          thumbnail: "https://img.youtube.com/vi/69MSII3rEDg/hqdefault.jpg",
          type: "video",
        },
        {
          id: "p-2",
          title: "Mendelssohn Violin Concerto Excerpt",
          description: "A classical violin concerto excerpt demonstrating technical precision and musical expression.",
          context: "Classical Violin",
          composer: "Felix Mendelssohn",
          youtubeId: "CuEgDfbwG9s",
          embedUrl: "https://www.youtube.com/embed/CuEgDfbwG9s",
          thumbnail: "https://img.youtube.com/vi/CuEgDfbwG9s/maxresdefault.jpg",
          type: "video",
        },
      ],
    },
  ],

  compositions: [
    {
      id: "c-1",
      title: "Only Gone From Me",
      subtitle: "SATB",
      year: "2025",
      type: "Written",
    },
    {
      id: "c-2",
      title: "God Will Provide",
      subtitle: "SATB",
      year: "2026",
      type: "Written",
    },
    {
      id: "c-3",
      title: "Man Of Sorrows",
      subtitle: "SATB",
      year: "2026",
      type: "Written",
    },
    {
      id: "c-4",
      title: "How Great Thou Art",
      subtitle: "SATB",
      year: "2026",
      type: "Arranged",
    },
    {
      id: "c-5",
      title: "Go Tell It on the Mountain",
      subtitle: "Piano",
      year: "2025",
      type: "Arranged",
    },
  ],

  selectedRoles: [
    { role: "Worship Team & Choir", organization: "First Baptist Church Waco", period: "2025\u2013Present" },
    { role: "Camp Counselor", organization: "Frontier Christian Camp", period: "2025\u2013Present" },
    { role: "Bible Study Leader", organization: "Baylor University Student Bible Study", period: "2025\u2013Present" },
    { role: "Worship Music Leader", organization: "Baylor University Reform University Fellowship Chapel", period: "2024\u20132025" },
    { role: "Choral Scholar / Worship Leader", organization: "Trophy Club United Methodist Church", period: "2023\u20132025" },
    { role: "Worship Leader for Wednesday Youth", organization: "Bridgeway Church", period: "2016\u20132024" },
    { role: "Childcare Provider & VBS Leadership", organization: "Bridgeway Church", period: "2016\u20132024" },
  ],

  repertoire: [
    "Classical Tenor Repertoire \u2014 Art Songs & Sacred Works",
    "Contemporary Worship",
    "Hymn Arrangements \u2014 Piano & Guitar",
    "Chamber Music \u2014 Violin Ensemble Works",
    "Original Worship Compositions & Arrangements",
    "Musical Theatre Selections",
    "Jazz Bass & Vocal Performance",
  ],

  recentWork: [
    {
      id: "rw-1",
      title: "Baylor Chapel Worship",
      role: "Worship Leader",
      date: "2024\u20132025",
      description: "Led weekly Reform University Fellowship chapel worship services at Baylor University.",
    },
    {
      id: "rw-2",
      title: "First Baptist Church Waco",
      role: "Worship Team & Choir",
      date: "2025\u2013Present",
      description: "Serving on the Sunday Morning Worship Team and Choir.",
    },
    {
      id: "rw-3",
      title: "Frontier Christian Camp",
      role: "Camp Counselor",
      date: "2025\u2013Present",
      description: "Serving as a camp counselor, leading worship sessions and mentoring youth.",
    },
  ],

  accomplishments: [
    { title: "Baylor University Concert Choir", category: "Choirs" },
    { title: "Baylor University Men's Choir", category: "Choirs" },
    { title: "Baylor University Campus Orchestra", category: "Choirs" },
    { title: "Baylor Chamber Singers", category: "Choirs" },
    { title: "TMEA All-State Choir 2022, 2023, 2024 (1st Chair Bass 1)", category: "Awards" },
    { title: "Composer/Arranger of Worship Music", category: "Musical Achievements" },
    { title: "Perfect Pitch", category: "Musical Achievements" },
    { title: "Musical Theatre Experience", category: "Musical Achievements" },
  ],

  scholarships: [
    "Baylor University Dean's List",
    "Duke TIP Scholar",
    "AP Scholar",
    "TMEA Texas Music Scholar",
  ],

  skills: [
    "Public Speaking",
    "Leadership",
    "Writing",
    "Musician \u2014 Vocals, Violin, Piano, Guitar, Bass, Drums",
    "Musical Theatre",
    "Perfect Pitch",
  ],
};